// 忘记密码
<template>
  <div class="forget-form-padding">
	<header2/>
    <el-card shadow="none" class="forget-form" v-show="step == 1">
      <div class="bottom-margin-lg forget-header">
        <span class="form-title">修改密码</span>
        <span class="form-desc">验证码将会发送至你的注册手机</span>
      </div>
      <el-form ref="forgetForm1" :model="forgetForm1" label-position="left" :rules="rules" label-width="80px">
        <el-input v-model="forgetForm1.phone" class="bottom-margin-lg" placeholder="请输入注册的手机号"></el-input>
        <!-- <el-row type="flex" class="bottom-margin-lg" justify="space-between">
          <el-col :span="15">
            <el-input v-model="forgetForm.validateCode" placeholder="请输入内容"></el-input>
          </el-col>
          <el-col :span="9">
            <el-image :src="captchaImageUrl" @click="refreshCaptchaImage" style="height: 40px"
                      fit="scale-down"/>
          </el-col>
        </el-row> -->
		<Verify
		  @success="capctchaCheckSuccess"
		  :mode="'pop'"
		  :captchaType="'blockPuzzle'"
		  :imgSize="{ width: '330px', height: '155px' }"
		  ref="verify"
		></Verify>
        <el-button style="width: 100%" type="primary" @click="getCaptchaVerify()">下一步</el-button>
      </el-form>
    </el-card>
    <el-card shadow="none" class="forget-form" v-show="step == 2">
      <div class="bottom-margin-lg forget-header">
        <span class="form-title">修改密码</span>
        <span class="form-desc">验证码已发送至你的注册手机</span>
      </div>
      <el-form ref="forgetForm" :model="forgetForm" label-position="left" label-width="80px">
        <el-input v-model="forgetForm1.phone" class="bottom-margin-lg" placeholder="请输入注册的手机号"></el-input>
        <el-input v-model="forgetForm.smsCode" class="bottom-margin-lg" placeholder="输入4位短信验证码"></el-input>
        <el-button style="width: 100%" type="primary" @click="submitForm">下一步</el-button>
      </el-form>
    </el-card>
    <el-card shadow="none" class="forget-form" v-show="step == 3">
      <div class="bottom-margin-lg forget-header">
        <span class="form-title">设置新密码</span>
        <span class="form-desc">新密码长度介于 8 和 20 之间，包含大小写字母、数字和特殊字符，不可出现重复或连续的字符，不可与之前设置过的密码重复。</span>
      </div>
      <el-form ref="forgetForm" :model="forgetForm" label-position="left" label-width="80px">
        <el-input v-model="forgetForm.password" class="bottom-margin-lg" placeholder="新密码"></el-input>
        <el-input v-model="forgetForm.checkPassword" class="bottom-margin-lg" placeholder="再次输入新密码"></el-input>
        <el-button style="width: 100%" type="primary" @click="submitForm">重置密码</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  import {sendValidateMessage, checkSmsCode, resetPassword} from "@/api/forget"
  import header2 from '@/components/base/header2.vue'
  import Verify from "@/components/Verifition/Verify";
  import { encrypt } from "@/util/jsencrypt";

  export default {
    data() {
		
      return {
        step: 1,
		forgetForm1: {
		  phone: "",
		},
        forgetForm: {
          validateCode: "",
          smsCode: "",
          password: "",
          checkPassword: ""
        },
        captchaImageUrl: '/api/captcha/captchaImage?type=char',
        ruleForm: {
          userName: '',
          password: '',
          validateCode: ''
        },
        rules: {
		  phone: [
		    {required: true, message: '请输入手机号码', trigger: 'blur'},
		  ],
          userName: [
            {required: true, message: '请输入用户名', trigger: 'blur'},
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'blur'},
          ]
        }
      }
    },
    mounted() {
    },
    created() {
    },
	components: {
	  header2,
	  Verify
	},
    computed: {},
    methods: {
      // 刷新验证码图片
      // refreshCaptchaImage() {
      //   this.captchaImageUrl = '/api/captcha/captchaImage?type=char&s=' + Math.random()
      // },
	  
	  getCaptchaVerify(){
		  
		if(!this.forgetForm1.phone){
			this.$message.error('请输入手机号码')
			return false;
		}
		  
	  	this.$refs['forgetForm1'].validate((valid) => {
	  		if (valid) {
	  			this.$refs.verify.show();		  
	  		} else {
	  		    console.log('error get captcha!!')
	  		    return false;
	  		}
	  		})
	  },
	  
	  capctchaCheckSuccess(params){
		  // 发送手机验证码
		  sendValidateMessage(this.forgetForm1.phone, this.forgetForm.validateCode, params.captchaVerification).then(res => {
		    if (res.data.code == 500) {
		      this.$message.error(res.data.msg)
		    } else {
		      this.step = 2
		    }
		  })
	  },
	  
      submitForm() {
        switch (this.step) {
          // case 1:
          //   // 发送手机验证码
          //   sendValidateMessage(this.forgetForm.phone, this.forgetForm.validateCode).then(res => {
          //     if (res.data.code == 500) {
          //       this.$message.error(res.data.msg)
          //     } else {
          //       this.step = 2
          //     }
          //   })
          //   break
          case 2:
            // 验证手机验证码
            checkSmsCode(this.forgetForm1.phone, this.forgetForm.smsCode).then(res => {
              if (res.data.code == 500) {
                this.$message.error(res.data.msg)
              } else {
                this.step = 3
              }
            })
            break
          case 3:
            // 新密码校验
            if (!this.validatePassword()) return;
			var pwd = encrypt(this.forgetForm.password);
            resetPassword(this.forgetForm1.phone, pwd).then(res => {
              if (res.data.code == 500) {
                this.$message.error(res.data.msg)
              } else {
                this.$message.success("密码修改成功")
                this.$router.push("/")
              }
            })
            break
          default:
            break
        }
      },
      validatePassword() {
		  
		const reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,20}$/
		// const regRepeat = /(\\w)\\1{2,}/;
		//console.log(reg.test(value));
		if (!(reg.test(this.forgetForm.password))) {
		  this.$message.error("密码长度介于 8 和 20 之间,且包含大小写字母、数字和特殊字符")
		  return false;
		}
		
		var ifLx = false;
		var arr = (this.forgetForm.password).split('');
		for (var i = 1; i < arr.length-1; i++) {
			if(arr[i+1].charCodeAt() - arr[i].charCodeAt() == 1 || arr[i+1].charCodeAt() == arr[i].charCodeAt()){
				ifLx = true;
				break;				  
			}
		}
		if(ifLx){
			this.$message.error("密码中不能出现重复或连续的字符")
			return false;
		}
		  
        if (this.forgetForm.password != this.forgetForm.checkPassword) {
          this.$message.error("两次密码需要一致")
          return false
        }

        return true
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/common.css";
  @import "../../assets/css/login.css";
  @import "../../assets/css/forget.css";
</style>